import { createApi, createHttpClient, type ApiError } from '@dt-pm/core';
import { coreConfig, env } from '@/app/config/env';
import { webTokenStorage } from './token-storage';

/** Evento global de sessao invalida — o AuthProvider escuta e derruba a sessao. */
export const UNAUTHORIZED_EVENT = 'dtpm:unauthorized';
export const FORBIDDEN_EVENT = 'dtpm:forbidden';

export const http = createHttpClient({
  config: coreConfig,
  tokenStorage: webTokenStorage,
  onUnauthorized: (error) => {
    window.dispatchEvent(new CustomEvent<ApiError>(UNAUTHORIZED_EVENT, { detail: error }));
  },
  onForbidden: (error) => {
    window.dispatchEvent(new CustomEvent<ApiError>(FORBIDDEN_EVENT, { detail: error }));
  },
  onRequestFinished: (info) => {
    if (!env.isProduction) {
      console.debug(`[api] ${info.method} ${info.path} -> ${info.status} (${info.durationMs}ms)`);
    }
  },
});

export const api = createApi(http);
